



































import { Vue, Component, Prop } from 'vue-property-decorator';

import { EWidgetThemes, WidgetThemesDictionary } from '@/models/Widget/themes';

import Typography from '@/components/atoms/Typography/Typography.vue';

type WidgetColorSelectSize = 'small' | 'medium' | 'large';

@Component({
  components: {
    Typography
  }
})
export default class WidgetColorSelect extends Vue {
  @Prop({ default: EWidgetThemes.BLUE }) value!: EWidgetThemes;
  @Prop({ default: 'small' }) size!: WidgetColorSelectSize;
  @Prop({ default: false }) gradientColor?: boolean;
  @Prop({ default: false }) showActiveLabel?: boolean;
  @Prop({ default: false }) isInternalPage?: boolean;
  @Prop({ default: false }) disabled?: boolean;

  get colors() {
    return Object.entries(WidgetThemesDictionary).map(
      ([colorName, colorData]) => ({
        name: colorName,
        gradient: colorData.primaryGradient,
        value: colorData.primaryColor
      })
    );
  }

  isActive(value: string) {
    return this.value === value;
  }

  selectTheme(color: EWidgetThemes) {
    this.$emit('input', color);
  }

  getStyle(color: string) {
    return `background: ${color}`;
  }
}
